var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopoverArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 12,
    viewBox: "0 0 40 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8777 8.24793L30.8433 3.65901C32.2418 2.58326 33.9566 2 35.721 2H40V0H0V2H4.27902C6.04338 2 7.75824 2.58326 9.15671 3.65901L15.1223 8.24793C17.9979 10.4599 22.0021 10.4599 24.8777 8.24793Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 2H35.721C33.9566 2 32.2418 2.58326 30.8433 3.65901L24.8777 8.24793C22.0021 10.4599 17.9979 10.4599 15.1223 8.24793L9.15671 3.65901C7.75824 2.58326 6.04338 2 4.27902 2H0",
    stroke: "#E7E9EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoverArrow);
export default __webpack_public_path__ + "static/media/PopoverArrow.c3b326f16fca04590c6003e82f3e1669.svg";
export { ForwardRef as ReactComponent };